import { PartialTranslation } from '../translations';

export const mn: PartialTranslation = {
  newChat: 'Шинэ чат',
  search: 'Хайх',
  user: 'Хэрэглэгч',
  settings: 'Тохиргоо',
  language: 'Хэл',
  getHelp: 'Тусламж авах',
  viewAllPlans: 'Бүх төлөвлөгөөг харах',
  learnMore: 'Илүү ихийг мэдэх',
  logOut: 'Гарах',
  chooseLanguage: 'Хэл сонгох',
  chooseYourPreferredLanguage: 'Өөрийн дуртай хэлээ сонгоно уу',
  searchLanguages: 'Хэл хайх...',
  autoDetect: 'Автомат илрүүлэх',
  noLanguagesFound: 'Хэл олдсонгүй',
  askAnything: 'Юу ч асууж болно',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Хувийн',
  freePlan: 'Үнэгүй төлөвлөгөө',
  current: 'Одоогийн',
  close: 'Хаах',
  archive: 'Архив',
  delete: 'Устгах',
  confirmDelete: 'Та энэ чатыг устгахдаа итгэлтэй байна уу?',
  confirmArchive: 'Та энэ чатыг архивлахдаа итгэлтэй байна уу?',
  deleteCannotUndo: 'Энэ үйлдлийг буцаах боломжгүй.',
  archiveCanFind: 'Архивласны дараа архивын жагсаалтаас олж болно.',
  resources: 'Нөөц',
  addResource: 'Нөөц нэмэх',
  deleteResource: 'Нөөц устгах',
  noMatchingResourcesFound: 'Тохирох нөөц олдсонгүй',
  noResourcesAvailable: 'Боломжтой нөөц алга',
  hideResources: 'Нөөцийг нуух',
  showResources: 'Нөөцийг харуулах',
  typeMessage: 'Мессеж бичих...',
  thinkingOptions: 'Бодох сонголтууд',
  deleteFile: 'Файл устгах',
  clearSelection: 'Сонголтыг арилгах',
  addAttachment: 'Хавсралт нэмэх',
  sendMessage: 'Мессеж илгээх',
  deepInsight: 'Гүн ойлголт · Гадаргуугийн шинжилгээ',
  deepInsightDesc: 'Гол санааг хурдан ойлгох',
  deepExploration: 'Гүн судалгаа · Иж бүрэн шинжилгээ',
  deepExplorationDesc: 'Олон талт гүн судалгаа',
  deepDeconstruction: 'Гүн задлан шинжилгээ · Системтэй аргумент',
  deepDeconstructionDesc: 'Давхаргын дарааллын шинжилгээ',
  contractReview: 'Гэрээний хянан үзэлт · Эрсдэл илрүүлэх',
  contractReviewDesc: 'Заалтын шинжилгээ болон дагаж мөрдөх шалгалт',
  textPolish: 'Текст боловсруулах · Мэргэжлийн илэрхийлэл',
  textPolishDesc: 'Хэлний оновчтол болон бүтцийн тохируулга',
  legalDocuments: 'Хуулийн баримт бичиг · Стандарт төсөл',
  legalDocumentsDesc: 'Мэргэжлийн хуулийн баримт бичих',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Нэвтрэх',
  register: 'Бүртгүүлэх',
  welcomeBack: 'LawHelper-д тавтай морилно уу',
  loginSubtitle: 'Таны AI хуулийн судалгааны туслах',
  continueWithGoogle: 'Google-ээр үргэлжлүүлэх',
  continueWithMicrosoft: 'Microsoft-оор үргэлжлүүлэх',
  continueWithWeChat: 'WeChat-ээр үргэлжлүүлэх',
  orContinueWith: 'эсвэл үргэлжлүүлэх',
  emailTab: 'Имэйл',
  phoneTab: 'Утас',
  emailPlaceholder: 'Имэйлээ оруулна уу',
  phonePlaceholder: 'Утасны дугаар оруулна уу',
  codePlaceholder: '6 оронтой код оруулна уу',
  sending: 'Илгээж байна...',
  verifying: 'Баталгаажуулж байна...',
  verify: 'Баталгаажуулах',
  sendMagicLink: 'Шидэт холбоос илгээх',
  getVerificationCode: 'Код авах',
  resendCode: 'Код дахин илгээх',
  resendIn: 'Дахин илгээх',
  magicLinkSent: 'Шидэт холбоос таны имэйл рүү илгээгдсэн',
  magicLinkHint: 'Бид таны имэйл рүү найдвартай холбоос илгээнэ',
  otpSent: 'Баталгаажуулах код илгээгдсэн',
  agreeToTerms: 'Үргэлжлүүлснээр та зөвшөөрч байна',
  privacyPolicy: 'Нууцлалын бодлого',
  termsOfService: 'Үйлчилгээний нөхцөл',
  and: 'ба',
  privacyTitle: 'Таны нууцлал чухал',
  privacyIntro: 'Бид танд хамгийн сайн туршлага өгөхийн тулд күүки болон ижил төстэй технологиуд ашигладаг.',
  essentialCookies: 'Чухал күүки',
  essentialDesc: 'Вэбсайт ажиллахад шаардлагатай',
  analyticsCookies: 'Аналитик күүки',
  analyticsDesc: 'Үйлчилгээг сайжруулахад тусалдаг',
  marketingCookies: 'Маркетингийн күүки',
  marketingDesc: 'Хувийн контентод ашиглагдана',
  acceptAll: 'Бүгдийг зөвшөөрөх',
  essentialOnly: 'Зөвхөн чухал',
  customize: 'Тохируулах',
  savePreferences: 'Тохиргоо хадгалах',
  back: 'Буцах',
  readPrivacyPolicy: 'Манай нууцлалын бодлогыг унших',
  cookiePolicy: 'Күүки бодлого',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI хяналт',
  aiDraft: 'AI ноорог',
  smartAssistant: 'Загвар',

  // 知识库搜索
  enableKnowledgeSearch: 'Хайлтыг идэвхжүүлэх',
  knowledgeSearchDesc: 'AI таны бичиг баримтаас хайдаг',
  clickToDisable: 'Идэвхгүй',
  clickToEnable: 'Идэвхжүүлэх',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Нөөцийн самбарыг хаах',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'Түргэн хариулт',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'Цуцлах',
  library: 'Номын сан',
  filterAll: 'Бүгд',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'Бодож байна...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Үйлчилгээний алдаа',
  uploaded: 'Байршуулсан',
  settingsGeneral: 'Ерөнхий',
  settingsNotifications: 'Мэдэгдэл',
  settingsAppearance: 'Харагдах байдал',
  settingsProfile: 'Профайл',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Цайвар',
  settingsDark: 'Бараан',
  settingsSystem: 'Систем',
  about: 'Тухай',
  reviewTitle: 'Баримт бичгийн хянан шалгалт',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Хянаж байна...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Хуулийн баримт бичиг бэлтгэх',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Үүсгэж байна...',
  generatedSuccess: '✅ Баримт бичиг үүссэн!',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'Түүх',
  drafterNoHistory: 'Түүх байхгүй',
  drafterNewChat: 'Шинэ чат',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Баримт хадгалах',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Гарах',
  drafterConfirm: 'Батлах',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Бэлэн',
  workflowCompleted: 'Дууссан',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Зогсоох',
  restartWorkflow: 'Restart',
  startDrafting: 'Бэлтгэлийг эхлэх',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Гэрээ',
  docTypeAgreement: 'Хэлцэл',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Захидал',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Ухаалаг баримтын туслах',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Алдаа',
  unknownError: 'Үл мэдэгдэх алдаа',
  file: 'Файл',
  loading: 'Ачаалж байна...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI шинжилгээ',
};
